import type { RefObject } from 'react'

import {
    gsap,
    registerGsap,
    useGSAP
} from '@/lib/gsap'

/**
 * Infinite horizontal marquee, recreated from the Webflow PAGE_START loop
 * (IX2 list a-79). The marked track must contain two identical copies of its
 * content so the loop is seamless. The track slides by 50% (one full copy)
 * and repeats forever.
 *
 *   data-marquee                 marker (required)
 *   data-marquee-duration="40"   seconds for one full cycle (optional)
 *   data-marquee-direction="left|right"
 */
export const useMarquee = (scope: RefObject<HTMLElement | null>): void => {
    useGSAP(
        () => {
            registerGsap()

            const root = scope.current
            if (!root) return

            const tracks = root.querySelectorAll<HTMLElement>('[data-marquee]')

            tracks.forEach(track => {
                const duration = Number(track.dataset.marqueeDuration) || 40
                const toRight = track.dataset.marqueeDirection === 'right'

                gsap.fromTo(
                    track,
                    { xPercent: toRight ? -50 : 0 },
                    {
                        xPercent: toRight ? 0 : -50,
                        duration,
                        ease: 'none',
                        repeat: -1
                    }
                )
            })
        },
        { scope }
    )
}
